"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HorizontalView = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@dbi-tools/ui-kit");

var _row = require("@dbi-tools/ui-kit/lib/components/row");

var _col = require("@dbi-tools/ui-kit/lib/components/col");

var _linkButtons = _interopRequireDefault(require("../../link-buttons"));

var _contentUi = _interopRequireDefault(require("../../content/content-ui"));

var _linkUi = _interopRequireDefault(require("../../link/link-ui"));

var _const = require("../../link/const");

var _photoLayout = require("../photo-layout.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var HorizontalView = function HorizontalView(_ref) {
  var setRef = _ref.setRef,
      btnColor = _ref.btnColor,
      headline1 = _ref.headline1,
      headline2 = _ref.headline2,
      imageText = _ref.imageText,
      headline1Color = _ref.headline1Color,
      headline2Color = _ref.headline2Color,
      renditionSrc = _ref.renditionSrc,
      _ref$boxPadding = _ref.boxPadding,
      boxPadding = _ref$boxPadding === void 0 ? [60, 0] : _ref$boxPadding,
      isTablet = _ref.isTablet,
      link = _ref.link,
      linkTitle = _ref.linkTitle,
      altText = _ref.altText,
      imageLink = _ref.imageLink;
  var isHeaderBlockExist = headline1 || headline2 || imageText;
  var imageRef = (0, _react.useRef)(null);

  var updateRef = function updateRef() {
    if (setRef) {
      setRef(imageRef);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_row.Row, null, /*#__PURE__*/_react.default.createElement(_col.Col, {
    sm: 12,
    lg: 9.5,
    alignSelf: "center",
    noGutter: isTablet
  }, isHeaderBlockExist && /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
    p: boxPadding
  }, headline1 && /*#__PURE__*/_react.default.createElement(_photoLayout.ItemOverlineStyled, {
    as: "h4",
    color: headline1Color,
    align: "center"
  }, headline1), headline2 && /*#__PURE__*/_react.default.createElement(_photoLayout.ItemHeadlineStyled, {
    as: "h4",
    color: headline2Color,
    align: "center"
  }, headline2), imageText &&
  /*#__PURE__*/
  // TODO remove temp solution
  // @ts-ignore
  _react.default.createElement(_photoLayout.ItemDescriptionStyled, {
    as: "div",
    measure: "lg",
    color: headline2Color
  }, /*#__PURE__*/_react.default.createElement(_contentUi.default, null, imageText)))), /*#__PURE__*/_react.default.createElement(_col.Col, {
    smOffset: 1,
    sm: 11,
    lg: 13.5,
    noGutter: isTablet
  }, /*#__PURE__*/_react.default.createElement(_photoLayout.ImageWrapperStyled, null, imageLink ? /*#__PURE__*/_react.default.createElement(_linkUi.default, {
    link: imageLink,
    target: (0, _const.linkTarget)(imageLink)
  }, /*#__PURE__*/_react.default.createElement("img", {
    onLoad: updateRef,
    loading: "lazy",
    ref: imageRef,
    src: renditionSrc,
    alt: altText || headline1
  })) : /*#__PURE__*/_react.default.createElement("img", {
    onLoad: updateRef,
    loading: "lazy",
    ref: imageRef,
    src: renditionSrc,
    alt: altText || headline1
  }))), linkTitle && link && /*#__PURE__*/_react.default.createElement(_col.Col, {
    smOffset: 13,
    lgOffset: 10,
    sm: 11,
    lg: 14,
    noGutter: isTablet
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
    display: "flex",
    justifyContent: {
      sm: 'center',
      lg: 'flex-end'
    }
  }, /*#__PURE__*/_react.default.createElement(_linkButtons.default, {
    color: btnColor,
    buttons: [{
      link: link,
      text: linkTitle,
      type: 'link'
    }]
  })))));
};

exports.HorizontalView = HorizontalView;